import { render, staticRenderFns } from "./CompleteLogo.vue?vue&type=template&id=37d1d511"
import script from "./CompleteLogo.vue?vue&type=script&lang=js"
export * from "./CompleteLogo.vue?vue&type=script&lang=js"
import style0 from "./CompleteLogo.vue?vue&type=style&index=0&id=37d1d511&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports